import type { ReactNode } from 'react'
import styles from './DisclosureSection.module.css'

export interface DisclosureSectionProps {
  title: string
  children: ReactNode
  defaultOpen?: boolean
}

/** Native `<details>` — real keyboard and screen-reader semantics for free. */
export function DisclosureSection({
  title,
  children,
  defaultOpen = false,
}: DisclosureSectionProps) {
  return (
    <details className={styles['details']} open={defaultOpen}>
      <summary className={styles['summary']}>{title}</summary>
      <div className={styles['content']}>{children}</div>
    </details>
  )
}
